import detailDefault from '../../detailDefault';
/* eslint-disable-next-line camelcase */
export default class detailaon_product_solutions extends detailDefault {
    load(sAction, data) {
        // call immediately after detailView is load

        const product = sAction.dataGet(`${data.prefix}/fields/product/value`);
        let licenseId = sAction.dataGet(`${data.prefix}/fields/if4if_licenses_aon_product_solutions_1_name/def/id_value`);
        sAction.dsClear();
        if (product) {
            sAction.dsAdd('set', `${data.prefix}/fields/product/def/readonly`, true);
            sAction.dsAdd('set', `${data.prefix}/fields/product_${product}/def/readonly`, true);
        }
        if (
            !licenseId && !['detail', 'rightPanel/detail'].includes(data.prefix) && sAction.dataGet(`view/module`) === 'acm_license_model'
        ) {
            const licenseName = sAction.dataGet('view/fields/if4if_licenses_acm_license_model_1_name/value');
            licenseId = sAction.dataGet('view/fields/if4if_licenses_acm_license_model_1_name/def/id_value');
            const id = sAction.dataGet('view/id');

            sAction.dsAdd('set', `${data.prefix}/fields/if4if_licenses_aon_product_solutions_1if4if_licenses_ida/value`, licenseId);
            sAction.dsAdd('set', `${data.prefix}/fields/if4if_licenses_aon_product_solutions_1_name/value`, licenseName);
            sAction.dsAdd('set', `${data.prefix}/fields/if4if_licenses_aon_product_solutions_1_name/def/id_value`, licenseId);
            sAction.dsAdd('set', `${data.prefix}/fields/aon_product_solutions_acm_license_model_1_rel/value`, `^${id}^`);
            sAction.dsAdd('set', `${data.prefix}/fields/aon_product_solutions_acm_license_model_1_rel/def/options`, {
                id: [id],
                names: [sAction.dataGet('view/name')],
                rel_type: [],
            });
        }
        this.setVisibleFields(sAction, data.prefix, product);
        sAction.dsProcess();

        this.setLicenseModelFilter(sAction, data.prefix, licenseId);
    }

    update(sAction, data) {
        // call immediately after detailView field is update
        if (data.field === 'if4if_licenses_aon_product_solutions_1if4if_licenses_ida') {
            this.setLicenseModelFilter(sAction, data.prefix, data.value.id);
        } else if (data.field === 'product') {
            sAction.dsClear();
            this.updateName(sAction, data.prefix, data.value);
            sAction.dsAdd('set', `${data.prefix}/fields/product_${data.value}/value`, '1');
            sAction.dsAdd('set', `${data.prefix}/changes/fields/product_${data.value}`, '1');
            if (data.prevValue) {
                sAction.dsAdd('set', `${data.prefix}/fields/product_${data.prevValue}/value`, '0');
                sAction.dsAdd('set', `${data.prefix}/changes/fields/product_${data.prevValue}`, '0');
            }
            this.setVisibleFields(sAction, data.prefix, data.value);
            sAction.dsProcess();
        } else if (data.field.startsWith('product_')) {
            const product = data.value? data.field.substring(8) : '';
            sAction.dsClear();
            sAction.dsAdd('set', `${data.prefix}/fields/product/value`, product);
            sAction.dsAdd('set', `${data.prefix}/changes/fields/product`, product);
            this.updateName(sAction, data.prefix, product);
            this.setVisibleFields(sAction, data.prefix, product);
            sAction.dsProcess();
        }
    }

    setLicenseModelFilter(sAction, data, licenseId) {
        // set filter for license model field in detail view
        const filter = licenseId? [{
            operandType: 'relate',
            parentId: licenseId,
            module: 'IF4IF_Licenses',
            relationship: ['if4if_licenses_acm_license_model_1'],
            name: 'if4if_licenses_aon_product_solutions_1',
            type: 'eq',
        }] : [];
        sAction.dataSet(`${data}/fields/aon_product_solutions_acm_license_model_1_rel/def/defaultFilter`, filter);
    }

    setVisibleFields(sAction, prefix, product) {
        const elements = ['elements_on_premise', 'elements_hosted', 'elements_api'].includes(product);
        const iwb = ['iwb_on_premise', 'iwb_hosted'].includes(product);
        const modellingService = ['account_modelling_service', 'portfolio_modelling_service'].includes(product);
        const ifToolkit = ['if_toolkit_uds_api', 'if_toolkit_mts_api', 'if_toolkit_risk_mapping_ui'].includes(product);

        for (const p of sAction.getEnumForSelect(sAction.dataGet(`${prefix}/fields/product/def/options`))) {
            sAction.dsAdd('set', `${prefix}/fields/product_${p.value}/def/visible`, p.value === product);
        }
        sAction.dsAdd('set', `${prefix}/fields/elements_type/def/visible`, elements);
        sAction.dsAdd('set', `${prefix}/fields/elements_version/def/visible`, elements);
        sAction.dsAdd('set', `${prefix}/fields/elements_license_key/def/visible`, elements);
        sAction.dsAdd('set', `${prefix}/fields/elements_license_key_end_date/def/visible`, elements);
        sAction.dsAdd('set', `${prefix}/fields/iwb_type/def/visible`, iwb);
        sAction.dsAdd('set', `${prefix}/fields/iwb_version/def/visible`, iwb);
        sAction.dsAdd('set', `${prefix}/fields/iwb_license_key/def/visible`, iwb);
        sAction.dsAdd('set', `${prefix}/fields/iwb_license_key_end_date/def/visible`, iwb);
        sAction.dsAdd('set', `${prefix}/fields/modelling_service_frequency/def/visible`, modellingService);
        sAction.dsAdd('set', `${prefix}/fields/if_toolkit_uds_end_date/def/visible`, product === 'if_toolkit_uds_api');
        sAction.dsAdd('set', `${prefix}/fields/if_toolkit_mts_end_date/def/visible`, product === 'if_toolkit_mts_api');
        sAction.dsAdd('set', `${prefix}/fields/if_toolkit_risk_mapping_end_date/def/visible`, product === 'if_toolkit_risk_mapping_ui');
        sAction.dsAdd('set', `${prefix}/fields/if_toolkit_type/def/visible`, ifToolkit);
    }

    updateName(sAction, prefix, product) {
        const name = product? sAction.translateEnum('product_solutions_enum', product) : '';
        sAction.dsAdd('set', `${prefix}/fields/name/value`, name);
        sAction.dsAdd('set', `${prefix}/changes/fields/name`, name);
        sAction.dsAdd('set', `${prefix}/name`, name);
    }
}
